import { AppTopNav } from "@/components/app-top-nav";
import { InactivityTimeout } from "@/components/inactivity-timeout";
import { useTitle } from "@/hooks/use-title";

import { type LayoutProps } from "./layout.types";

export const Layout = (props: LayoutProps) => {
  const { children, isAuthenticated } = props;
  const { title } = useTitle();

  const titleNode = title.length > 0 && (
    <h1
      data-test-id="navbar-title"
      className="mb-4 font-bold text-primary text-3xl"
    >
      {title}
    </h1>
  );

  if (isAuthenticated) {
    return (
      <div className="flex min-h-full w-full flex-col">
        <AppTopNav />
        <main className="flex w-full flex-1 flex-col">
          <div className="mx-auto w-full max-w-(--breakpoint-xl) px-4 md:px-8 flex flex-1 flex-col py-4 md:py-8">
            {titleNode}
            {children}
          </div>
        </main>
        <InactivityTimeout />
      </div>
    );
  }

  return (
    <main className="min-h-full w-full overflow-auto">
      <div className="mx-auto w-full max-w-(--breakpoint-xl) px-4 md:px-8 py-8">
        {titleNode}
        {children}
      </div>
    </main>
  );
};
